var _ellipse, _mask, _g, _mask2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardReminders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48.8583,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2",
    fillOpacity: 0.6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 97
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48.8583,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.21777,
    y: 65.5537,
    width: 106.435,
    height: 31.3043,
    fill: "#DFE1E5"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 97
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48.8583,
    rx: 48,
    ry: 48,
    fill: "#EEF0F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1095,
    y: 79.8687,
    width: 59.23,
    height: 2.46924,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6361 23.98L33.7368 33.112",
    stroke: "#BBD3F9",
    strokeWidth: 1.16955,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.436 25.9007L61.6965 33.6601",
    stroke: "#BBD3F9",
    strokeWidth: 1.16955,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0745 79.1916L61.8552 71.6201",
    stroke: "#BBD3F9",
    strokeWidth: 1.16955,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1422 78.8311L33.8961 71.0718",
    stroke: "#BBD3F9",
    strokeWidth: 1.16955,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8646 80.406C31.4208 80.406 32.6823 79.1445 32.6823 77.5884C32.6823 76.0323 31.4208 74.7708 29.8646 74.7708C28.3085 74.7708 27.047 76.0323 27.047 77.5884C27.047 79.1445 28.3085 80.406 29.8646 80.406Z",
    fill: "#3175E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9478 80.406C66.5039 80.406 67.7654 79.1445 67.7654 77.5884C67.7654 76.0323 66.5039 74.7708 64.9478 74.7708C63.3916 74.7708 62.1301 76.0323 62.1301 77.5884C62.1301 79.1445 63.3916 80.406 64.9478 80.406Z",
    fill: "#3175E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.085,
    y: 22.4348,
    width: 1.32022,
    height: 7.34603,
    fill: "#F5AA2C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3678,
    y: 19.7532,
    width: 2.9939,
    height: 7.31716,
    rx: 1.49695,
    transform: "rotate(90 51.3678 19.7532)",
    fill: "#F5AA2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7093 76.85C61.8742 76.85 73.3571 65.697 73.3571 51.9391C73.3571 38.1812 61.8742 27.0283 47.7093 27.0283C33.5444 27.0283 22.0615 38.1812 22.0615 51.9391C22.0615 65.697 33.5444 76.85 47.7093 76.85Z",
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5502 74.0054C59.6243 74.0054 69.4123 64.2174 69.4123 52.1434C69.4123 40.0693 59.6243 30.2814 47.5502 30.2814C35.4762 30.2814 25.6882 40.0693 25.6882 52.1434C25.6882 64.2174 35.4762 74.0054 47.5502 74.0054Z",
    fill: "#76A7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8628 35.3978C20.8628 35.3978 33.954 29.6469 42.0746 23.2602C42.0746 23.2602 36.9306 12.8566 25.7034 19.5612C25.6889 19.5467 15.8488 25.8178 20.8628 35.3978Z",
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7927 23.1421C53.7927 23.1421 65.0922 31.8984 74.5855 35.9876C74.5855 35.9876 81.2756 26.4943 70.0339 19.8331C70.0195 19.8331 59.8181 14.1834 53.7927 23.1421Z",
    fill: "#4788F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.5457,
    y: 60.7319,
    width: 25.7091,
    height: 24.9328,
    transform: "rotate(-43.1438 38.5457 60.7319)",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5649 64.381C54.7072 64.381 60.4972 58.591 60.4972 51.4487C60.4972 44.3064 54.7072 38.5165 47.5649 38.5165C40.4227 38.5165 34.6327 44.3064 34.6327 51.4487C34.6327 58.591 40.4227 64.381 47.5649 64.381Z",
    fill: "#9FC1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7617 51.0008L55.0069 49.108L64.8903 48.3277L55.3103 50.8275L49.7184 51.4488L49.7617 51.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2363 53.6739L43.9388 57.9509L39.8063 62.2135L42.6095 57.0406L45.9184 53.1682L46.2363 53.6739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9101 52.177C50.0358 50.8183 49.0362 49.6149 47.6775 49.4891C46.3187 49.3634 45.1153 50.363 44.9896 51.7217C44.8639 53.0805 45.8634 54.2839 47.2222 54.4096C48.5809 54.5353 49.7843 53.5357 49.9101 52.177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 76.4256,
    y1: 79.8687,
    x2: 12.2533,
    y2: 79.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 51.4002,
    y1: 60.7319,
    x2: 51.1789,
    y2: 79.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardReminders);
export default __webpack_public_path__ + "static/media/dashboardReminders.d1adf5ecc3f6af531255c5dba402cb8d.svg";
export { ForwardRef as ReactComponent };